import { de_DE_formal } from "@App/locales/de_DE-formal";
import { de_DE_globalTranslations } from "@App/locales/de_DE-globalTranslations";

export const dkvMobility = {
  ...de_DE_formal,
  ...{
    translation: {
      ...de_DE_globalTranslations.translation,
      "Partnerwerkstaetten in Ihrer Naehe": "Werkstätten in Ihrer Nähe",
      hero: {
        title: "<strong>Werkstatt-Termine einfach online buchen</strong>",
        subtitle: "powered by repareo und DKV Mobility",
      },
      layout: {
        backText: "Zurück zu dkv-mobility.com",
        navbar: {
          partnerLogo: {
            alt: "DKV Mobility",
          },
        },
      },
      linkToHome: "https://werkstatt.repareo.de/partner/dkv-mobility",
    },
  },
};
